import React from 'react';
import { useSelector } from 'react-redux';
import { TRANSLATIONS } from '../../constants';
import { useTranslate } from '../../hooks/common';
import { Attribute } from '../../models';
import { getCertImage } from '../../services';
import { ApplicationState } from '../../store';
import Flex, { FlexDirection, FlexJustification, FlexWrap } from '../common/Flex';
import Jumbotron from '../common/Jumbotron';
import AttributeItem from './AttributeItem';

export interface DigitalNameplateProps {
    attributes: Attribute[];
    certImageIds: string[];
}

const DigitalNameplate = ({ attributes, certImageIds }: DigitalNameplateProps) => {
    const language = useSelector((state: ApplicationState) => state.translation.language);
    const translate = useTranslate();

    const getAttributes = (attributes?: Attribute) =>
        attributes ? attributes.attributeTranslations.map(x => <AttributeItem key={x.order} attributeData={x} />) : <></>;

    const renderCertImages = (certImageIds: string[]) => {
        const images = certImageIds.map(x => <img key={x} className='cert-image' src={getCertImage(x)} />);

        return <Jumbotron>
            <Flex direction={FlexDirection.Row} justification={FlexJustification.FlexStart} wrap={FlexWrap.Wrap}>{images}</Flex>
        </Jumbotron>;
    };

    return (
        <>
            <div className='section-title'>{translate(TRANSLATIONS.main.digitalNameplate)}</div>
            <div className='digital-nameplate'>
                {getAttributes(attributes.find(x => x.language == language))}
                {certImageIds.length > 0 && renderCertImages(certImageIds)}
            </div>
        </>
    );
};

export default DigitalNameplate;
